import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator function that checks if two form controls have matching values.
 * Typically used for password confirmation fields.
 *
 * @param controlName - The name of the primary control
 * @param matchingControlName - The name of the control that should match
 * @param errorProperty - The error key to use (defaults to 'mustMatch')
 * @returns A ValidatorFn that returns a validation error if values don't match
 *
 * @example
 * ```typescript
 * this.form = this.fb.group({
 *   password: ['', Validators.required],
 *   confirmPassword: ['', Validators.required]
 * }, {
 *   validators: [mustMatch('password', 'confirmPassword')]
 * });
 * ```
 */
export function mustMatch(
  controlName: string,
  matchingControlName: string,
  errorProperty: string = 'mustMatch',
): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (!control || !matchingControl) {
      return null;
    }

    if (control.value !== matchingControl.value) {
      return { mustMatch: errorProperty };
    }

    return null;
  };
}
